import { useState } from 'react';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { useRoleSetupStyles } from '../RoleSetup/role-setup.styles';
import { researchPanelInterestOptions } from '../../constants';
import { useRoleSetupTranslationRef } from '../../translation';

interface ResearchPanelInterestProps {
  handleBack: () => void;
  handleSubmit: (researchPanelInterest: boolean) => Promise<void>;
  isSubmitting?: boolean;
}

export const ResearchPanelInterest = ({
  handleBack,
  handleSubmit,
  isSubmitting = false,
}: ResearchPanelInterestProps) => {
  const classes = useRoleSetupStyles();
  const { t } = useTranslationRef(useRoleSetupTranslationRef);

  const [selectedResearchPanelInterest, setSelectedResearchPanelInterest] =
    useState(true);

  return (
    <Box className={classes.container}>
      <Box className="headerWrapper">
        <Typography variant="body1" className="headerTitle">
          {t('researchPanelInterest.headerTitle')}
        </Typography>
        <Typography variant="body1" className="headerDesc">
          {t('researchPanelInterest.headerDesc1')}
          <br />
          {t('researchPanelInterest.headerDesc2')}
        </Typography>
      </Box>

      <Box className="researchPanelInterestOptionWrapper">
        {researchPanelInterestOptions.map(({ name, value, Icon }) => (
          <Box
            className={`researchPanelInterestOptionItemWrapper ${selectedResearchPanelInterest === value ? 'selected' : ''}`}
            key={name}
            onClick={() => setSelectedResearchPanelInterest(value)}
          >
            <Icon className="icon" />
            <Typography variant="body1" className="label">
              {name}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box className="researchPanelInterestButtonWrapper">
        <Button
          variant="contained"
          className="backButton"
          onClick={handleBack}
          disableRipple
          disabled={isSubmitting}
        >
          {t('button.back')}
        </Button>

        <Button
          variant="contained"
          className="buttonFilled"
          onClick={() => handleSubmit(selectedResearchPanelInterest)}
          disableRipple
          disabled={isSubmitting}
        >
          {t('button.submit')}
        </Button>
      </Box>
      <Box className={`${classes.infoWrapper} fixed`}>
        <ErrorOutlineIcon />
        <Typography variant="body1" className="infoText">
          {t('researchPanelInterest.info')}
        </Typography>
      </Box>
    </Box>
  );
};
